export default "__VITE_ASSET__8fb774ca__"